import React from 'react';

const icon = () => (
  <span className="svg-icon">
    <svg width="60" height="54" viewBox="0 0 60 54" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path stroke="currentColor" strokeLinejoin="round" d="M13 10.96V1h34v9.96M12.48 43H3c-1.105 0-2-.895-2-2V13c0-1.105.895-2 2-2h54c1.105 0 2 .895 2 2v28c0 1.105-.895 2-2 2H47" />
        <path stroke="currentColor" strokeLinejoin="round" d="M47 25v28H13V25" />
        <path d="M23 33h18" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round" />
        <path d="M7 25h46" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M23 39h18m-18 6h18" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round" />
        <path fill="currentColor" fillRule="nonzero" d="M18 32h2v2h-2zm0 6h2v2h-2zm0 6h2v2h-2z" />
      </g>
    </svg>
  </span>
);

export default icon;
